import React, { Fragment, useState } from 'react';
import Dropdown from '../Dropdown/Dropdown';
import DropdownItem from '../Dropdown/DropdownItem';
import Field from '../Field/Field';
import { uid } from '../_utils';
import { FieldType } from '../_types';
import TableFilterRow from './TableFilterRow';
import './TableGrid.css';
var TableGrid = function (props) {
    var _a = props.items, items = _a === void 0 ? [] : _a, _b = props.fields, fields = _b === void 0 ? [] : _b, _c = props.filters, filters = _c === void 0 ? [] : _c, _d = props.sortColumns, sortColumns = _d === void 0 ? [] : _d, actions = props.actions, _e = props.showActionIcons, showActionIcons = _e === void 0 ? false : _e, _f = props.selectMode, selectMode = _f === void 0 ? false : _f, _g = props.responsive, responsive = _g === void 0 ? false : _g, _h = props.showFilter, showFilter = _h === void 0 ? false : _h, _j = props.small, small = _j === void 0 ? false : _j, _k = props.bordered, bordered = _k === void 0 ? false : _k, _l = props.striped, striped = _l === void 0 ? false : _l, onFetchItems = props.onFetchItems, onFocusRowChange = props.onFocusRowChange, onSelectedRowChange = props.onSelectedRowChange, onDetailsToggle = props.onDetailsToggle, onFilter = props.onFilter, onSort = props.onSort;
    var _m = useState(null), selectedItem = _m[0], setSelectedItem = _m[1];
    var internalSort = function () { return sortColumns || []; };
    var tableClass = function (responsive, small, striped, bordered) {
        var className = 'table table-hover';
        if (responsive)
            className += ' table-responsive';
        if (small)
            className += ' table-sm';
        if (striped)
            className += ' table-striped';
        if (bordered)
            className += ' table-bordered';
        return className;
    };
    var handleFocusRowChange = function (item, nativeEvent) {
        setSelectedItem(item);
        onFocusRowChange === null || onFocusRowChange === void 0 ? void 0 : onFocusRowChange(item, nativeEvent);
    };
    var sortBy = function (field, sortable) {
        if (sortable === true) {
            var sortedField = getSortedField(field);
            var direction = '';
            if (!sortedField)
                direction = 'asc';
            else if (sortedField.direction === 'asc')
                direction = 'desc';
            else if (sortedField.direction === 'desc')
                direction = '';
            var sort = {
                name: field === null || field === void 0 ? void 0 : field.name,
                direction: direction
            };
            onFetchItems({ sort: sort });
            if (onSort && field)
                onSort(field, direction);
        }
    };
    var sortDirection = function (field) {
        var sortedField = getSortedField(field);
        return sortedField && sortedField.direction
            ? sortedField.direction
            : '';
    };
    var getSortedField = function (field) { var _a; return (_a = internalSort()) === null || _a === void 0 ? void 0 : _a.find(function (x) { return (x === null || x === void 0 ? void 0 : x.name) === (field === null || field === void 0 ? void 0 : field.name); }); };
    var handleDetailsToggle = function (item, field, nativeEvent) {
        if (field.expandable)
            onDetailsToggle === null || onDetailsToggle === void 0 ? void 0 : onDetailsToggle({ item: item, field: field }, nativeEvent);
    };
    var sortHeaderClass = function (field) {
        return getSortedField(field) != null
            ? 'sortheader'
            : '' || field.sortable
                ? 'sortable'
                : '';
    };
    var sortIconClass = function (field) {
        var className = 'fal';
        var direction = sortDirection(field);
        if (direction === '')
            className += ' fa-sort';
        else if (direction === 'asc')
            className += ' fas fa-caret-up';
        else if (direction === 'desc')
            className += ' fas fa-caret-down';
        return className;
    };
    var getFieldContent = function (field, item) {
        var itemValue = field.name ? item[field.name] : undefined;
        if (field.type === FieldType.Checkbox)
            return field.formatter
                ? field.formatter(itemValue)
                : itemValue
                    ? 'Yes'
                    : 'No';
        else if (field.type === FieldType.Select) {
            var option = field.options &&
                field.options.find(function (o) { return o.value === itemValue; });
            return field.formatter ? field.formatter(itemValue) : option === null || option === void 0 ? void 0 : option.text;
        }
        return field.formatter ? field.formatter(itemValue) : itemValue;
    };
    return (React.createElement("table", { id: uid('s-table'), className: tableClass(responsive, small, striped, bordered) },
        React.createElement("thead", null,
            React.createElement("tr", null,
                fields.map(function (field) { return (React.createElement("th", { key: field.name, className: sortHeaderClass(field), onClick: function () { return sortBy(field, field.sortable); } },
                    field.sortable && (React.createElement("span", { className: "float-right sort-icon", "aria-hidden": "true" },
                        React.createElement("span", { className: "float-right" },
                            React.createElement("i", { className: sortIconClass(field) })))),
                    React.createElement("div", { className: "ellipsis-header" }, field.heading))); }),
                selectMode ? React.createElement("th", null, "\u00A0") : null,
                (actions === null || actions === void 0 ? void 0 : actions.length) ? React.createElement("th", null, "\u00A0") : null)),
        React.createElement("tbody", { className: "stable-row" },
            showFilter && (React.createElement(TableFilterRow, { fields: fields, filters: filters, selectMode: selectMode, actions: actions, onFetchItems: onFetchItems, onFilter: onFilter })),
            items.map(function (item, itemIndex) { return (React.createElement(Fragment, { key: itemIndex },
                React.createElement("tr", { key: item.id, className: "stable-row" + (selectedItem &&
                        (item === null || item === void 0 ? void 0 : item.id) &&
                        item.id === selectedItem.id
                        ? ' selected'
                        : '') + (item.rowClass ? " " + item.rowClass : ''), onClick: function (nativeEvent) {
                        return handleFocusRowChange(item, nativeEvent);
                    } },
                    fields.map(function (field, fieldIndex) { return (React.createElement("td", { key: fieldIndex },
                        !!field.expandable && !!item.detailsSlot && (React.createElement("span", null,
                            React.createElement("button", { className: "btn btn-none", onClick: function (nativeEvent) {
                                    return handleDetailsToggle(item, field, nativeEvent);
                                } },
                                React.createElement("i", { className: "fal fa-chevron-" + (item.expanded
                                        ? 'down'
                                        : 'right') + " fg-digital-blue" })))),
                        getFieldContent(field, item))); }),
                    selectMode && (React.createElement("td", null,
                        React.createElement(Field, { value: {
                                value: item.selected
                            }, field: {
                                name: 'value',
                                type: FieldType.Checkbox
                            }, onChange: function (event, nativeEvent) {
                                onSelectedRowChange === null || onSelectedRowChange === void 0 ? void 0 : onSelectedRowChange(item, !item.selected, nativeEvent);
                            } }))),
                    (actions === null || actions === void 0 ? void 0 : actions.length) ? (React.createElement("td", { className: "column-actions" },
                        React.createElement(Dropdown, { id: "btnAction" + itemIndex, text: "Actions", variant: "subtle" }, actions.map(function (action, actionIndex) { return (React.createElement(DropdownItem, { id: "" + action.name.replace(/ /g, '_') + itemIndex, key: "btnActionAction" + itemIndex + "_" + actionIndex, text: action.name, iconClass: showActionIcons
                                ? action.iconClass
                                : '', onClick: function () { var _a; return (_a = action === null || action === void 0 ? void 0 : action.onClick) === null || _a === void 0 ? void 0 : _a.call(action, item); } })); })))) : null),
                !!item.expanded && !item.detailsWithoutTdSlot && (React.createElement("tr", { key: item.id + "-details" },
                    React.createElement("td", { colSpan: fields.length + 3 }, item.detailsSlot))),
                !!item.expanded && item.detailsWithoutTdSlot && (React.createElement("tr", { key: item.id + "'-details-without-td", className: "background-grey" }, item.detailsWithoutTdSlot)),
                !!item.expanded &&
                    item.detailsWithoutTdSlot &&
                    item.detailsRowSlot,
                !!item.expanded &&
                    item.detailsWithoutTdSlot &&
                    item.detailsErrorSlot)); }))));
};
export default TableGrid;
